package org.company.app.data.model

import kotlinx.serialization.Serializable

@Serializable
data class HttpErrorResponse(val message: String?)
